import React from 'react';
import { ProjectMaterialsStats } from './ProjectMaterialsStats';
import { ProjectMaterialsLowStock } from './ProjectMaterialsLowStock';
import { ProjectMaterialsPendingOrders } from './ProjectMaterialsPendingOrders';

export function ProjectMaterialsSidebar({ data }: { data: any }) {
  return (
    <div className="space-y-6">
      {/* Cơ cấu giá trị vật tư */}
      <ProjectMaterialsStats />

      {/* Vật tư sắp hết hàng */}
      <ProjectMaterialsLowStock items={data.lowStockItems} />

      {/* Đơn đặt hàng đang xử lý */}
      <ProjectMaterialsPendingOrders orders={data.pendingOrders} />
    </div>
  );
}
